<template>



  <v-container
    fluid
    grid-list-xl
  >
    <v-row>

    <v-btn to="/customerCreate" >
      {{$t("customers.list.create")}}
    </v-btn>
    </v-row>


    <v-row>
      <v-col cols="10">
        <v-text-field

          :label="$t('global.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <material-card
           :title="$t('customers.list.title')"
        >

          <v-data-table
            :headers="headers"
            :items="customers"
            :search="search"
            @click:row="showCustomer"
            hide-default-footer
:items-per-page=1000
          >

            <template v-slot:item.active="{ item }">
              <div v-if="item.active">{{$t("global.yes")}}</div><div v-else>{{$t("global.no")}}</div>
            </template>

          </v-data-table>
        </material-card>
      </v-col>


    </v-row>
  </v-container>
</template>

<script>
    import api from '../components/backend/backend-api'

    export default {
        data: function () {
            return {
                search: '',
                headers: [
                    {
                        sortable: true,
                        text: this.$i18n.t("customer.name"),
                        value: 'name'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("customer.logicalName"),
                        value: 'logicalName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("customer.active"),
                        value: 'active'
                    }
                ],
                customers: []
            }
        },
    methods: {

        showCustomer(rowdata) {
            this.$router.push({path: '/customerShow/' + rowdata.id});
        },
        getCustomers () {
            api.getCustomers().then(response => {
                this.customers = response
                //   console.log(response.data)
            })
                .catch(error => {
                     this.$store.commit('setErrorMsg', error)
                        console.log(error)
                //    this.errors.push(error)
                })
        }

    },
    mounted() {
        this.getCustomers();
    },
  }
</script>
